module.exports = __webpack_public_path__ + "img/html-evolution-6.7bc87fa9.jpg";